import { render, staticRenderFns } from "./demo-index.vue?vue&type=template&id=150a8ed9&scoped=true&"
import script from "./demo-index.vue?vue&type=script&lang=js&"
export * from "./demo-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150a8ed9",
  null
  
)

export default component.exports